import React, { Fragment, useState } from 'react';
import classNames from 'classnames';
import { t } from 'translates';

const { algolia: { isUserStaff, currentLanguage } = {}, ecommerceStatus = false, waitlistStatus, bookCtaLabel = '' } = drupalSettings

function ProductCard({
  type = 'product',
  series_data,
  is_big = false,
  product_category,
  product_category_color,
  product_description,
  product_title,
  url,
  full_price,
  product_image,
  date,
  time,
  session_languages,
  in_stock,
  subscription_3rd_party,
  trackingEvent,
  sessions_count_label,
  has_session,
  handleClickBookNow: clickBookNowCb,
  handleClickWaitlist: clickWaitlistCb
}) {
  const [imgSrc, setImgSrc] = useState(product_image);

  const handleClickBookNow = (e) => {
    clickBookNowCb(e)
  };

  const handleClickWaitlist = (e) => {
    e.preventDefault();
    clickWaitlistCb(e)
  };

  const bookButton = () => {
    if (!ecommerceStatus) {
      return true;
    }

    if (type === 'product') {
      if (in_stock) {
        if (subscription_3rd_party) {
          return (
            <a
              href={url}
              className="session-new__btn"
              onClick={trackingEvent}
              onAuxClick={trackingEvent}
            >
              {bookCtaLabel}
            </a>
          )
        }
        else {
          return (
            <button type='button'
              className="session-new__btn"
              onClick={handleClickBookNow}
            >
              {bookCtaLabel}
            </button>
          )
        }
      } else {
        return (
          <button type='button'
            onClick={handleClickWaitlist}
            className="session-new__btn session-new__btn--white"
          >
            {Drupal.t('Subscribe to waitlist')}
          </button>
        )
      }
    }
    if (type === 'cursus') {
      if (series_data.isAvailable) {
        return (
          <a
            href={url}
            className="session-new__btn"
            onClick={trackingEvent}
            onAuxClick={trackingEvent}
          >
            {(bookCtaLabel.length > 0) ? bookCtaLabel : t('Book now', DT_SESSIONS)}
          </a>
        );
      }
      return (
        <a
          href={url}
          onClick={trackingEvent}
          className="session-new__btn session-new__btn--white"
        >
          {t('Coming soon', DT_CURSUS)}
        </a>
      );
    }
  }

  const handleError = () => setImgSrc(`${PUBLIC_PATH}images/fairy.png`);

  return (
    <div className={classNames('session-new', 'session-new--product',
      {
        'session-new--big': is_big
      }
    )}>
      <div className="session-new__header">
        <div className="session-new__label"
          style={{
            backgroundColor: product_category_color,
          }}
        >
          {product_category}
        </div>
        {product_image ? (
          <picture>
            <source srcSet={imgSrc} media='(min-width: 1024px)' />
            <img loading='lazy' src={imgSrc} alt="" onError={handleError} />
          </picture>
        ) : (
          <picture>
            <source srcSet={`${PUBLIC_PATH}images/fairy.png`} media='(min-width: 1024px)' />
            <img loading='lazy' src={`${PUBLIC_PATH}images/fairy.png`} alt="" />
          </picture>
        )}
        <a href={url} className="session-new__image"></a>
      </div>
      <div className="session-new__content">
        <div className="session-new__body">
          <h3 className="session-new__title">
            <a
              href={url}
              onClick={trackingEvent}
              onAuxClick={trackingEvent}
            >
              {product_title}
            </a>
          </h3>
          {ecommerceStatus && (
            <div className="session-new__subtitle">
              {type === 'product' && in_stock && has_session ? (
                  <Fragment>
                    <div className="session-new__session-info">
                      {`${t('Next session', DT_SESSIONSNEW)}: ${date} — ${time} ${session_languages}`}
                    </div>

                    {!subscription_3rd_party ? (
                      <button type='button' onClick={handleClickBookNow} className="session-new__available-sessions">
                        {sessions_count_label}
                      </button>
                    ) : (
                      <a className="session-new__available-sessions"
                        href={url}
                        onClick={trackingEvent}
                        onAuxClick={trackingEvent}>
                        {sessions_count_label}
                      </a>
                    )}
                  </Fragment>
              ) : null}
              {type === 'cursus' && (
                <Fragment>
                  {series_data.course_label} —
                  {Object.values(series_data.languages).map((element, index) => (
                    <span className="session-new__language" key={index}>{element}</span>
                  )
                  )}
                </Fragment>
              )}
            </div>
          )}
          {product_description ? (
            <div className="session-new__description">
              {product_description}
            </div>
          ) : ''}
        </div>
        <div className={classNames('session-new__footer', {
          'session-empty': waitlistStatus
        })}>
          {bookButton()}
          <div className="session-new__price">
            {full_price}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductCard
